import { render, staticRenderFns } from "./BattlesBetElement.vue?vue&type=template&id=b9ba06e6&scoped=true"
import script from "./BattlesBetElement.vue?vue&type=script&lang=js"
export * from "./BattlesBetElement.vue?vue&type=script&lang=js"
import style0 from "./BattlesBetElement.vue?vue&type=style&index=0&id=b9ba06e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ba06e6",
  null
  
)

export default component.exports